export default __webpack_public_path__ + "static/lower4_1-65b9389ae0fc5864319fde8e581bc69c.jpg";